import { Link } from 'components/common';
import { UpdatesItem, UpdatesListItem } from '.';

const UpdatesContentFi = () => (
  <div className="content">
    <UpdatesItem date="2026-10-26">
      <UpdatesListItem title="Paranna kurssia tekoälyn avulla">
        <p>
          Jos tekoälytoiminnallisuudet ovat käytössä, voit nyt tehdä arvion
          kurssin sisällöstä tekoälyn avulla ja saada ehdotuksia miten kurssia
          voi parantaa.
        </p>
        <p>
          Löydät toiminnallisuuden kurssin muokkausnäkymästä oikeasta
          ylälaidasta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-10-08">
      <UpdatesListItem title="Merkitse kurssi pakolliseksi">
        <p>
          Voit nyt merkitä kurssin pakolliseksi. Voit merkitä kurssin
          pakolliseksi kaikille osallistujille kurssin Asetukset{' -> '}
          Pakollisuus ja tavoiteaikataulu -sivulta. Vaihtoehtoisesti voit
          merkitä kurssin pakolliseksi vain valituille käyttäjille tai ryhmille
          kurssin Jaa-sivulta.
        </p>
        <p>
          Osallistujille näytetään, jos kurssi on merkitty pakolliseksi.
          Kurssit-sivulta voi myös suodattaa pakolliseksi merkittyjä kursseja.
        </p>
        <p>
          Vastuuhenkilöt voivat myös suodattaa pakolliseksi merkittyjä kursseja
          Tiimi{' -> '}Analytiikka{' -> '}Kurssit -sivulta ja nähdä, mille
          käyttäjille kurssi on merkitty pakolliseksi.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Kurssin pysyvä tavoiteaikataulu ryhmälle">
        <p>
          Voit nyt lisätä kurssin tavoiteaikataulun pysyvästi ryhmälle, jos
          kurssi on jaettu sille ryhmälle. Tämä tarkoittaa, että jos uusi
          käyttäjä lisätään ryhmään, hän saa automaattisesti sen ryhmän
          tavoiteaikataulun.
        </p>
        <p>
          Voit lisätä ryhmäkohtaisen tavoiteaikataulun kurssin Jaa-sivulta tai
          ryhmän Kurssit-sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-10-02">
      <UpdatesListItem title="Suoritusmatriisi">
        <p>
          Voit nyt seurata käyttäjien suoritustiloja suoritusmatriisista. Voit
          erikseen valita mitä kursseja, oppimispolkuja, muita suorituksia tai
          kalenteritapahtuma haluat lisätä matriisiin.
        </p>
        <p>
          Suoritusmatriisi on saatavilla kaikille admin-käyttäjille Analytiikka
          {' -> '}Suoritusmatriisi -sivulta ja kaikille vastuuhenkilöille Tiimi
          {' -> '}Suoritusmatriisi -sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-09-10">
      <UpdatesListItem title="Kategoriat oppimispoluille">
        Voit nyt lisätä kategorioita oppimispoluille. Kategorioiden lisääminen
        onnistuu oppimispolun Asetukset-sivulta. Tämän jälkeen näet kategoriat
        Oppimispolut-sivulla ja voit suodattaa kategorian mukaan.
      </UpdatesListItem>

      <UpdatesListItem title="Kategoriat muille suorituksille">
        Voit nyt myös lisätä kategorioita muille suorituksille. Kategorioiden
        lisääminen onnistuu suorituksen Asetukset-sivulta. Tämän jälkeen näet
        kategoriat Muut suoritukset -sivulla ja voit suodattaa kategorian
        mukaan.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-06-01">
      <UpdatesListItem title="Odottavat pyynnöt tiimisivulla">
        VAstuuhenkilöillä on nyt erillinen sivu kaikkien odottavien pyyntöjen
        tarkasteluun. Vastuuhenkilö löytää sivun polusta Tiimi{' -> '}
        Analytiikka{' -> '}Odottavat pyynnöt.
      </UpdatesListItem>

      <UpdatesListItem title="Piilota vanhenevat suoritukset tiimisivulla">
        Vastuuhenkilö voi nyt piilottaa vanhenevat tai vanhentuneet suoritukset
        tiimisivulla, jos suoritukset eivät ole relevantteja.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-05-04">
      <UpdatesListItem title="Tekoälykäännökset kurssin kieliversioille">
        <p>Kurssin kieliversion voi nyt kääntää tekoälyn avulla.</p>
        <p>
          Koko kieliversion voi kääntää kurssin Asetukset{' -> '}Kieliasetukset
          -sivulta.
        </p>
        <p>
          Voit myös kääntää yksittäisiä sisältöjä kurssin muokkausnäkymästä.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Ryhmäkeskustelut">
        <p>
          Voit nyt luoda ryhmäkeskustelu -tyyppisen suorituksen Muut suoritukset
          -sivulta.
        </p>
        <p>
          Ryhmäkeskustelu toimii keskustelun muistiinpanojen tapaan, mutta
          keskusteluun voi lisätä useamman osallistujan, ja jokainen osallistuja
          voi vastata kysymyksiin.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-03-28">
      <UpdatesListItem title="Kopioi osaaminen">
        <p>
          Voit nyt kopioida osaamisen. Tämä kopioi olemassa olevaan osaamisen
          tasot, kategoriat ja käyttäjän oikeudet.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Uusia monivalintatehtävän asetuksia">
        <p>
          Voit nyt valita kuinka monta vaihtoehtoa käyttäjän täytyy valita tai
          kuinka monta vaihtoehtoa käyttäjä voi valita monivalintatehtävässä.
          Voit myös asettaa, että vääristä valinnoista ei vähennetä pisteitä.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Valitse mitä sisältöjä sisällytetään kurssin pdf-vientiin">
        <p>
          Jos viet kurssin sisällön pdf-tiedostona, voit nyt valita mitä
          sisältötyyppejä tiedostoon sisällytetään.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2026-03-09">
      <UpdatesListItem title="Luo kurssin kieliversio toisesta kurssista">
        <p>
          Voit nyt luoda kurssin kieliversion toisesta olemassa olevasta
          kurssista. Kurssien sisältöjen pitää olla vastaavat niin, että
          kursseissa on sama määrä lukuja ja jokaisessa luvussa samat
          sisältöelementit.
        </p>
        <p>
          Löydät toiminnon kurssin Asetukset {'->'} Kieliasetukset -sivulta
          valitsemalla nuolen takaa "Tuo kurssilta".
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-12-16">
      <UpdatesListItem title="Kurssin kieliversiot">
        <p>
          Voit nyt luoda kieliversioita kursseista. Kieliversioita hallitaan
          kurssin Asetukset{' -> '}Kieliasetukset -sivulta.
        </p>
        <p>
          Kielikäännöksiä kurssin sisällöstä voi lisätä muuokkausnäkymästä tai
          tuomalla käännökset sisältävän JSON-tiedoston.
        </p>
        <p>
          Kun käyttäjä avaa kurssin joka tukee kieliversioita, käyttäjän pitää
          ensin valita millä kielellä hän haluaa suorittaa kurssin.
        </p>
        <p>
          Löydät lisätietoja kieliversioita oppaastamme täältä (luvun lopussa
          Kieliasetukset-otsikon alta):{' '}
          <a
            href="https://academy.vuolearning.fi/courses/kayttoohjeet/verkkokurssin-asetukset#38defb614c18a7df"
            target="_blank"
          >
            Vuolearning - verkkokurssin laatijan opas
          </a>
          .
        </p>
        <p>
          <em>Jatkokehitys:</em> Pyrimme hieman myöhemmin julkaisemaan työkalun
          jolla olemassa olevasta toisesta kurssista voi luoda kieliversion.
          Pyrimme myös lisäämään tuen tekoälyavusteisille kielikäännöksille.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Puolankielinen käyttöliittymäkäännös">
        Käyttöliittymä tukee nyt puolan kieltä kielivaihtoehtona.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-11-26">
      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Mukautetut sähköpostiviestipohjat"
      >
        <p>
          Voit nyt luoda mukautettuja viestipohjia järjestelmästä lähetettäville
          sähköpostiviesteille. Voit hallita viestipohjia Superadmin {'->'}{' '}
          Asetukset {'->'} Sähköposti -sivulta.
        </p>
        <p>
          Kaikki superadmin-käyttäjät voivat hallita viestipohjia. Jos haluat,
          että admin-käyttäjä voi hallita viestipohjia, voit antaa tälle
          &quot;Hallitse sähköpostipohjia&quot; -oikeuden.
        </p>
      </UpdatesListItem>
      <UpdatesListItem
        onlyForAdmin={true}
        title="Mukautetut sähköpostiviestipohjat"
      >
        <p>
          Järjestelmästä lähetettäville sähköpostiviesteille voi nyt luoda
          mukautettuja viestipohjia.
        </p>
        <p>
          Admin-käyttäjänä voit hallinnoida viestipohjia vain jos sinulle
          annetaan erillinen oikeus.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-10-21">
      <UpdatesListItem title="Keskustelun muistiinpanojen sulkeminen">
        <p>
          Voit nyt sallia keskustelun muistiinpanojen sulkemisen. Vastauksia
          suljetussa keskustelussa ei enää voi muokata. Jos keskustelu on
          asetettu luottamukselliseksi, voit myös vaatia kaikkien osapuolten
          hyväksyntää ennen keskustelun sulkemista.
        </p>
        <p>
          Löydät asetukset keskustelun sulkemisen sallimiseksi Pääsy ja näkyvyys
          -sivulta keskustelun muistiinpanot -suorituksessa.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-09-25">
      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Tekoälytyökalut sisällöntuotannossa"
      >
        <p>
          Voit nyt käyttää tekoälyavusteisia työkaluja sisällöntuotannossa
          kurssin muokkausnäkymässä. Työkalujen avulla voit generoida sisältöä
          antamalla tekoälylle syötteen ja halutessa olemassa olevaa
          kurssisisältöä kontekstiksi.
        </p>

        <p>
          Tekoälyn käytössä on kuukausittainen ympäristökohtainen käyttöraja,
          joka nollataan aina kuun vaihteessa.
        </p>

        <p>
          Jos tekoälytyökaluja ei näy muokkausnäkymässä, niin ne on saatettu
          ottaa pois käytöstä ympäristössäsi.
        </p>

        <p>
          Pääkäyttäjänä voit hallita tekoälyn käyttöön liittyviä asetuksia
          Superadmin{' -> '}Asetukset{' -> '}Tekoälyominaisuudet -sivulta. Tältä
          sivulta näet kuinka paljon tekoälytyökaluja on käytetty kuukausittain.
        </p>

        <p>
          Oletuksena tekoälytyökalujen käyttö on sallittu kaikille
          admin-käyttäjille, mutta tämän voi estää asetuksista. Jos työkalut
          eivät ole käytössä kaikilla admin-käyttäjille, niin yksittäisille
          admin-käyttäjille voi antaa erillisen oikeuden käyttää
          tekoälytyökaluja Superadmin{' -> '}
          Adminit sivulta.
        </p>
      </UpdatesListItem>

      <UpdatesListItem
        onlyForAdmin={true}
        title="Tekoälytyökalut sisällöntuotannossa"
      >
        <p>
          Voit nyt käyttää tekoälyavusteisia työkaluja sisällöntuotannossa
          kurssin muokkausnäkymässä. Työkalujen avulla voit generoida sisältöä
          antamalla tekoälylle syötteen ja halutessa olemassa olevaa
          kurssisisältöä kontekstiksi.
        </p>

        <p>
          Tekoälyn käytössä on kuukausittainen ympäristökohtainen käyttöraja,
          joka nollataan aina kuun vaihteessa.
        </p>

        <p>
          Jos tekoälytyökaluja ei näy muokkausnäkymässä, niin ne on saatettu
          ottaa pois käytöstä ympäristössäsi.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-06-23">
      <UpdatesListItem title="Luottamukselliset keskustelun muistiinpanot">
        <p>
          Keskustelun muistiinpanot -suorituksen keskustelun voi nyt asettaa
          luottamukselliseksi. Suorituksen omistaja voi sallia tämän Pääsy ja
          näkyvyys -sivun asetuksista.
        </p>

        <p>
          Jos keskustelu asetetaan luottamukselliseksi, niin ainoastaan
          käyttäjät joille on annettu pääsyoikeus voivat nähdä käyttäjän
          vastaukset. Huomaa, että keskustelun asettaminen luottamukselliseksi
          on pysyvä toimenpide, eikä sitä voi perua.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Lähetä sähköpostiviesti kun käyttäjä ilmoittautuu kalenteritapahtumaan">
        Voit nyt lähettää sähköpostiviestin mihin tahansa osoitteisiin kun
        käyttäjä ilmoittautuu kalenteritapahtumaan. Tämä voi olla hyödyllistä
        jos olet esim. tapahtuman järjestetäjä ja haluat ilmoituksen aina kun
        joku ilmoittautuu tapahtumaan. Löydät tämän asetukset
        kalenteritapahtuman Osallistumisasetukset -sivulta.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-05-18">
      <UpdatesListItem title="Vaihtoehtoinen asettelu etusivun bannerikuvalle">
        Etusivun bannerikuva voidaan nyt näyttää vaihtoehtoisella asettelulla,
        jossa kuva skaalautuu näkymän leveyden mukaan ja kuvan mittasuhteet
        säilyvät samana.
      </UpdatesListItem>

      <UpdatesListItem title="Päivitetty käyttöliittymän ulkoasu">
        Käyttöliittymän ulkoasua on päivitetty leveämmällä näkymällä,
        päivitetyillä navigointityyleillä ja muilla pienemmillä
        tyylimuutoksilla.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-04-23">
      <UpdatesListItem title="Tallenna suodatusvalintoja Käyttäjät-sivulla">
        <p>
          Voit nyt tallentaa suodatusvalintoja Käyttäjät-sivulla, jos
          esimerkiksi käytät samoja valintoja säännöllisesti. Voit kokeilla
          toimintoa valitsemalla suodatusvalintoja ja painamalla
          Tallenna-painiketta valintojen vieressä.
        </p>

        <p>
          Suodatusvalintojen tallentaminen on ensi alkuun saatavilla vain
          Käyttäjät-sivulla, mutta tulemme myöhemmin päivittämään toiminnon myös
          muille sivuille joissa on suodatusvalintoja.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-02-20">
      <UpdatesListItem title="Sähköpostivahvistus kalenteritapahtumaan ilmoittautumisesta">
        Voit nyt asettaa päälle sähköpostivahvistuksen kun käyttäjä ilmoittautuu
        kalenteritapahtumaan. Viesti sisältää tapahtuman tiedot ja mahdolliset
        käyttäjäkohtaiset ilmoittautumistiedot. Löydät asetuksen
        kalenteritapahtuman Osallistumisasetukset-sivulta.
      </UpdatesListItem>

      <UpdatesListItem title="Yksivalintatehtävä">
        Kursseihin voi nyt lisätä yksivalintatehtävän, joka toimii muuten
        samalla tavalla kuin monivalintatehtävä, mutta käyttäjä voi aina valita
        vain yhden vastausvaihtoehdon.
      </UpdatesListItem>

      <UpdatesListItem title="Tuki usealle liitteelle suorituksissa">
        Muut suoritukset -sivun suorituksiin voi nyt liittää useamman
        liitetiedoston.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2025-01-28">
      <UpdatesListItem title="Kurssin versiohistoria">
        <p>
          Voit nyt tarkastella historiaa kurssin sisällön versioista. Uusi
          versio luodaan automaattisesti, kun muutoksia kurssin sisältöön
          tallennetaan. Voit myös tehdä seuraavia:
        </p>
        <ul>
          <li>
            <strong>Lisää tunniste versioon:</strong> voit lisätä tunnisteen
            tietyyn kurssin versioon, jotta versioiden seuraaminen olisi
            helpompaa.
          </li>
          <li>
            <strong>Palaa aiempaan versioon:</strong> voit palata aiempaan
            versioon kursissta. Tämä vaikuttaa vain lukujen sisältöön, eikä
            vaikuta kurssin asetuksiin. Voit myös tehdä saman yksittäiselle
            luvulle.
          </li>
          <li>
            <strong>Tarkastele minkä version käyttäjä suoritti:</strong> kurssin
            tehtävät ja analytiika -sivulla voit nähdä minkä version kurssista
            käyttäjä suoritti. Voit nähdä esikatselun kurssin sisällöstä ja
            käyttäjän vastauksista.
          </li>
        </ul>
        <p>
          Voit tarkastella versiohistoriaa, lisätä tunnisteita tai palata
          aiempaan versioon kurssin Muokkaa-sivun kautta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-12-10">
      <UpdatesListItem title="Ilmoitukset admin-käyttäjille etusivulla">
        <p>
          Admin-käyttäjät näkevät nyt ilmoituksia etusivulla tiedoista joihin
          heidän saattaisi olla hyvä reagoida. Toistaiseksi ilmoituksia
          näytetään seuraavista tiedoista:
        </p>
        <ul>
          <li>Arvostelemattomat tehtävät ylläpidetyiltä kursseilta</li>
          <li>Lukemattomat palautteet ylläpidetyiltä kursseilta</li>
          <li>Lukemattomat chat-viestit ylläpidetyiltä kursseilta</li>
          <li>
            Odottavat pyynnöt ylläpidetyiltä kursseilta, muista suorituksista
            tai kalenteritapahtumista
          </li>
        </ul>
      </UpdatesListItem>

      <UpdatesListItem title="Parannettu kalenteritapahtuman jonon hallinta">
        Jos rajoitat osallistujien määrää kalenteritapahtumassa, voit nyt valita
        haluatko käyttää jonoa ja kuinka monta käyttäjää voi liittyä jonoon.
        Käyttäjät näkevät myös oman sijoituksensa jonossa ja näkevät selkeämmän
        ilmoituksen jos tapahtuma on täynnä.
      </UpdatesListItem>

      <UpdatesListItem title="Parannettu tuki H5P-sisällöille">
        Paransimme tukea H5P-sisällöille joissa on monta sivua tai monta
        tehtävää. Jos yhdessä H5P-sisällössä on useaampi tehtävä, voit nyt
        täsmentää tämän muokkausnäkymässä, jotta pisteet laskettaisiin oikein.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-11-14">
      <UpdatesListItem title="Suodata voimassa olevia suorituksia">
        Voit nyt suodattaa voimassa olevia suorituksia, jos kurssin suoritus tai
        muu suoritus mahdollisesti vanhenee. Löydät suodatusvaihtoehdon
        esimerkiksi Käyttäjät-sivulta, kurssin Tehtävät ja analytiikka -sivulta
        tai muun suorituksen Käyttäjät-sivulta.
      </UpdatesListItem>

      <UpdatesListItem title="Muokkaa kurssin suorituslomaketta">
        Jos kurssille on asetettu läpäisyraja, niin voit nyt muokata kurssin
        lopussa näkyvää suorituslomaketta, jolla käyttäjä tarkastaa kurssin
        tuloset. Voit muuttaa lomakkeen otsikkoa, sisältöä tai painikkeen
        tekstiä.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-10-31">
      <UpdatesListItem title="Kommentit ja muutosten pyytäminen avointen kysymysten vastauksiin">
        <p>
          Voit nyt kommentoida avoimen kysymyksen vastauksia joita ei ole
          tarkoitus arvioida. Voit myös pyytää käyttäjältä muutoksia
          arvioitavaan vastaukseen ennen varsinaisen arvioinnin antamista.
          Kommentin tai arvioinnin lisäämisen yhteydessä voit myös halutessa
          lähettää käyttäjälle sähköposti-ilmoituksen.
        </p>
        <p>
          Löydät nämä toiminnot kurssin Tehtävät ja analytiikka -sivun kautta
          tarkastelemalla vastauksia avoimeen kysymykseen.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-10-17">
      <UpdatesListItem title="Päivityksiä kurssin ja oppimispolun analytiikan suodatukseen ja tietoihin">
        Kurssin Tehtävät ja analytiikka -sivun suodatusvalintoja on päivitetty,
        ja analytiikkatiedoissa on nyt enemmän dataa näkyvillä. Oppimispolun
        Seuraa-sivun suodatusvalintoja on myös päivitetty, ja sivulle on lisätty
        erillinen näkymä askelten suoritustietojen tarkasteluun.
      </UpdatesListItem>

      <UpdatesListItem title="Päivitys suostumuksen pyytämiseen">
        Kun uusi käyttäjä rekisteröityy oppimisalustalle, häneltä kysytään nyt
        ensin onko hän työ- tai sopimussuhteessa koulutuksen järjestäjään. Jos
        käyttäjä on työ- tai sopimussuhteessa, käyttäjältä ei enää erikseen
        pyydetä suostumusta käyttäjätietojen käsittelyyn. Tämän muutoksen on
        tarkoitus selkeyttää millä perusteella oppimisalustan käyttäjien tietoja
        voidaan käsitellä.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-07-11">
      <UpdatesListItem title="Parannettu suoritusten jakaminen oppimispolusta">
        Jos suoritus on lisätty oppimispolun askeleeseen, niin oppimispolun
        osallistujat saavat nyt automaattisesti pääsyn suoritukseen.
        Osallistujille ei kuitenkaan lisätä suoritusmerkintää automaattisesti,
        vaan tämä tapahtuu yhä ylläpitäjän toimesta tai käyttäjän itsensä
        toimesta jos hänelle on sallittu oikeus siihen.
      </UpdatesListItem>

      <UpdatesListItem title="Suoritukset-sivu nimetty uudelleen">
        "Suoritukset"-sivu on nimetty uudelleen "Muut suoritukset"-sivuksi.
        Muutoksen tarkoituksena on selkeyttää eroa kurssin suoritusten,
        oppimispolun suoritusten ja muiden tyyppisten suoritusten välillä.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-07-09">
      <UpdatesListItem title="Päivitetyt Käyttäjät-sivun suodattimet">
        Päivitimme Käyttäjät-sivun suodattimet jotta ne olisivat
        helppokäyttöisempiä. Voit nyt myös valita useampia arvoja suodattimissa,
        mikä tekee suodattamisesta joustavampaa. Jos avaat käyttäjän profiilin
        ja palaat takaisin, aktiiviset suodattimet myös säilyvät.
      </UpdatesListItem>

      <UpdatesListItem title="Osaamismatriisi">
        Löydät nyt uuden osaamismatriisin Käyttäjät-sivun alta. Osaamismatriisin
        avulla voit tarkastella dataa käyttäjien osaamisista ja
        osaamisprofiileista. Data voidaan myös viedä excel-tiedostoon.
      </UpdatesListItem>

      <UpdatesListItem title="Uusia suodatusmahdollisuuksia Suoritushistoria-sivulla">
        Analytiikka{' -> '}Suoritushistoria sivulle on lisätty uusia suodattimia
        suoritusten suodattamiseen.
      </UpdatesListItem>

      <UpdatesListItem title="Kalenteritapahtumien luominen samalla nimellä">
        Voit nyt luoda useita kalenteritapahtumia samalla nimellä. Aiemmin tämä
        ei ollut mahdollista, koska nimen piti olla uniikki. Jotta
        kalenteritapahtumien tunnistaminen olisi helpompaa, näytämme nyt
        tapahtuman aloitus- ja päättymisajan eri näkymissä käyttöliittymässä.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-05-21">
      <UpdatesListItem title="Käyttäjän yhteeveto-sähköposti">
        Jokainen käyttäjä voi nyt tilata itselleen yhteenveto-sähköpostin Omat
        tiedot{` -> `}Asetukset -sivun kautta. Sähköposti sisältää yhteenvedon
        käytäjään liittyvästä viimeaikaisesta toiminnasta edellisen päivän,
        viikon tai kuukauden ajalta. Käyttäjät voivat myös valita mistä
        tapahtumista he haluavat ilmoituksia, kuten uusista pääsyoikeuksista,
        lähestyvistä tavoiteaikatauluista tai vanhenevista suorituksista.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-05-02">
      <UpdatesListItem title="Oppimispolkujen julkaiseminen">
        <p>
          Lisäsimme oppimispolkuihin aloituspäivän ja valinnaisen
          päättymispäivän, jotka toimivat samalla tavalla kuin kursseissa. Tämä
          tarkoittaa, että uusi oppimispolku tulee julkaista ennen kuin se on
          saatavilla käyttäjille. Oppimispolun voi myös sulkea, jolloin
          askeleiden sisältö ei ole enää käyttäjien saatavilla.
        </p>

        <p>
          Kaikki olemassa olevat oppimispolut on automaattisesti julkaistu ja
          ovat saatavilla jos ne on jaettu käyttäjille.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Ranskankielinen käyttöliittymäkäännös">
        Käyttöliittymä tukee nyt ranskan kieltä kielivaihtoehtona.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-04-14">
      <UpdatesListItem title="Pakolliset tehtävät">
        Voit nyt asettaa tehtävän pakolliseksi. Tämä tarkoittaa, että käyttäjä
        ei voi suorittaa kurssia ennen kuin hän on vastannut pakolliseen
        tehtävään. Löydät asetuksen tehtäväelementeistä kurssin
        muokkausnäkymässä "Näytä lisä valintoja" valinnan alta.
      </UpdatesListItem>

      <UpdatesListItem title="Muutoksia sisällön piilottamiseen ennen vaastamista">
        Aiemmin kurssissa oli mahdollista piilottaa tehtävän jälkeen näkyvä
        sisältö yksittäisen luvun sisällä. Olemme nyt muuttaneet tätä asetusta
        niin, että tehtävän jälkeinen sisältö piilotetaan kaikista luvuista
        kunnes käyttäjä on vastannut. Löydät asetuksen tehtäväelementeistä
        muokkausnäkymässä "Näytä lisää valintoja" valinnan alta.
      </UpdatesListItem>

      <UpdatesListItem title="Valitse vaihtoehtojen lukumäärä kyselyssä">
        Voit nyt valita vastausvaihtoehtojen lukumäärän kysely-elementissä.
        Lisäsimme myös värikartta-asetuksen erilaisten kyselyiden vaihtoehtojen
        visualisointia varten. Löydät nämä asetukset kysely-elementistä kurssin
        muokkausnäkymässä.
      </UpdatesListItem>

      <UpdatesListItem title="Aseta linkki kalenteritapahtumalle">
        Lisäsimme erillisen linkkikentän kalenteritapahtuman asetuksiin aiemman
        sijantikentän lisäksi. Voit myös valinnaisesti asettaa linkin tekstin.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-03-12">
      <UpdatesListItem title="Suoritushistoria-sivu">
        Analytiikka-sivun alle on lisätty uusi Suoritushistoria-sivu, joka
        näyttää kaikki kurssisuoritukset, oppimispolun suoritukset, muut
        suoritukset ja kalenteritapahtuman osallistumiset alustalla.
        Admin-käyttäjät näkevät suoritukset kursseilta, oppimispoluilta,
        suorituksista ja kalenteritapahtumista joissa he ovat ylläpitäjiä.
        Vastuuhenkilöt näkevät lisäksi kaikki suoritukset oman tiiminsä
        käyttäjiltä.
      </UpdatesListItem>

      <UpdatesListItem title="Avoimen kysymyksen vastausten muokkaminen">
        Voit nyt sallia käyttäjien muokata vastaustaan avoimeen kysymykseen. Jos
        muokkaminen on sallittu, käyttäjä voi muokata vastaustaan kunnes kurssin
        on suoritettu tai kunnes vastaus on arvioitu. Löydät tämän asetuksen
        muokkausnäkymässä jokaisen Avoin kysymys -tehtävän kohdalta.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-02-14">
      <UpdatesListItem title="Kurssin vienti SCORM-paketiksi">
        Voit nyt viedä kurssin sisällön SCORM-paketiksi. Tämä mahdollistaa
        kurssin sisällön käyttämisen alustan ulkopuolella. Voit viedä
        SCORM-paketin kurssin Ylläpito-sivun alta Vie SCORM -sivulta.
      </UpdatesListItem>

      <UpdatesListItem title="Vaihtoehtoja tekstin muotoiluun">
        <p>
          Useissa asetuksissa voi nyt muotoilla tekstiä lihavoimalla,
          kursivoimalla tai alleviivaamalla tai lisäämällä linkkejä tekstin
          sekaan. Tämä on nyt mahdollista seuraavissa:
        </p>
        <ul>
          <li>Kurssin kuvaus</li>
          <li>Oppimispolun kuvaus</li>
          <li>Suorituksen kuvaus</li>
          <li>Tehtävälistojen tehtävät</li>
          <li>Keskustelun muistiinpanojen kysymykset</li>
          <li>Kalenteritapahtuman kuvaus</li>
          <li>Etusivun infoteksti</li>
          <li>Ryhmäkohtainen infoteksti</li>
        </ul>
      </UpdatesListItem>

      <UpdatesListItem title="Kopioi oppimispolku">
        Oppimispolun voi nyt kopioida uudeksi oppimispoluksi. Kaikki
        oppimispolun askeleet ja asetukset kopioidaan, mutta osallistujia ei
        kopioida. Tämä toiminto löytyy oppimispolun Ylläpito-sivulta.
      </UpdatesListItem>

      <UpdatesListItem title="Luo sisäisiä linkkejä kurssissa">
        Kurssin sisällä on nyt helpompi luoda linkkejä saman kurssin toiseen
        sisältöön. Muokkausnäkymässä jokaisen elementin oikeaan alakulmaan on
        lisätty painike josta voi kopioida linkin kyseiseen elementin. Linkin
        voi sen jälkeen liittää esimerkiksi Teksti-elementtiin. Loppukäyttäjän
        näkymässä kurssin sisäiset linkin avautuvat samassa välilehdessä tai
        ikunnassa sujuvampaa navigointia varten.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2024-02-01">
      <UpdatesListItem title="Lisää useampia suoritusmerkintöjä suorituksessa">
        <p>
          Voit nyt lisätä useita suoritusmerkintöjä käyttäjälle saman
          suorituksen sisällä. Jos uusi suoritusmerkintä lisätään, niin nykyinen
          merkintä arkistoidaan, mutta se on yhä saatavilla.
        </p>
        <p>
          Voit lisätä uuden suorituksen käyttäjälle lisäämällä käyttäjän Lisää
          käyttäjiä tai Lisää suoritusmerkintöjä -painikkeen kautta
          Käyttäjät-sivulla suorituksessa. Voit myös painaa kolmea pistettä
          käyttäjän kohdalla käyttäjälistassa ja valita Lisää uusi
          suoritusmerkintä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Kerää käyttäjätietoja kalenteritapahtuman osallistujilta">
        Voit nyt lisätä tietokenttiä kalenteritapahtumaan jotka käyttäjä voi
        täyttää kun hän liittyy kalenteritapahtumaan. Voit esimerkiksi kysyä
        ruoka-aineallergioista tiettyyn tapahtumaan osallistuvilta käyttäjiltä.
        Kalenteritapahtuman omistaja voi myös lisätä tai muokata osallistujien
        käyttäjätietoja. Kenttiä voi lisätä tapahtumaan
        Osallistumisasetukset-sivulta kalenteritapahtumassa.
      </UpdatesListItem>
      <UpdatesListItem title="Vie kalenteritapahtuman osallistujatiedot Exceliin">
        Voit nyt viedä kalenteritapahtuman osallistujatiedot Excel-tiedostoon.
        Löydät toiminnon Osallistujat-sivulta kalenteritapahtumassa.
      </UpdatesListItem>
      <UpdatesListItem title="Linkitä suorituksia kalenteritapahtumaan">
        Voit nyt linkittää suorituksia kalenteritapahtumaan. Kun käyttäjälle
        merkitään osallistumismerkintä, hänet lisätään automaattisesti
        linkitettyihin suorituksiin. Voit linkittää suorituksia
        Osallistumisasetukset-sivulta kalenteritapahtumassa.
      </UpdatesListItem>
      <UpdatesListItem title="Saksankielinen käyttöliittymäkäännös">
        Käyttöliittymä tukee nyt saksan kieltä kielivaihtoehtona.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-12-13">
      <UpdatesListItem title="Uudistettu Tiimi-sivu">
        Vastuuhenkilöiden Tiimi-sivu on uudistettu. Vastuuhenkilöt voivat nyt
        nähdä tarkempaa analytiikkaa kursseista, oppimispoluista, suorituksista
        ja kalenteritapahtumista joihin heidän tiiminsä käyttäjät ovat
        osallistuneet.
      </UpdatesListItem>
      <UpdatesListItem title="Uusia suodattimia Käyttäjät-sivulla">
        Voit nyt suodattaa käyttäjiä "Käyttäjä ei estetty" ja "Tili ei
        vanhentunut" suodattimilla Käyttäjät-sivulla.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-19">
      <UpdatesListItem title="Uudet käyttäjien Excel-raportit">
        <p>
          Käyttäjät-sivulla on nyt saatavilla uudet Excel-raportit. Uusien
          raporttien avulla voit valita mitä tietoja haluat viedä sekä valita
          rivien järjestyksen ja mitä sarakkeita tiedostoon sisällytetään.
          Saatavilla on 6 eri tyyppistä raporttia:
        </p>
        <ul>
          <li>Käyttäjät</li>
          <li>Suoritushistoria</li>
          <li>Kurssit</li>
          <li>Oppimispolut</li>
          <li>Suoritukset</li>
          <li>Kalenteritapahtumat</li>
        </ul>
        <p>
          Voit ladata uudet raportit Käyttäjät-sivulta painamalla oikeasta
          yläkulmasta kolmea pistettä ja valitsemalla "Vie Exceliin".
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-11">
      <UpdatesListItem title="Arviontitavan valitseminen avoimessa kysymyksessä">
        Jos avoin kysymys on asetettu arvioitavaksi, niin voit nyt valita miten
        tehtävä arvioidaan. Vaihtoehdot ovat pelkkä teksti, teksti ja tähtiarvio
        tai teksti ja pisteet.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-10-03">
      <UpdatesListItem title="Käyttäjän lisämäät suoritukset">
        Voit nyt antaa käyttäjille oikeuden merkitä itselleen suorituksen. Tämä
        onnistuu suorituksen ylläpitäjän näkymästä Pääsy ja näkyvyys
        -asetuksista. Asetuksissa voi myös määrittää, täytyykö ylläpitäjän
        hyväksyä käyttäjien lisäämät suoritukset vai voiko käyttäjä lisätä ne
        suoraan ilman hyväksyntää.
      </UpdatesListItem>

      <UpdatesListItem title="Käyttäjän muokkaamat tehtävälistat ja keskustelun muistiinpanot">
        <p>
          Tehtävälista-suorituksissa voi nyt antaa käyttäjille oikeuden merkitä
          yksittäisiä tehtäviä suoritetuksi. Samoin Kekustelun muistiinpanot
          -suorituksissa voi antaa käyttäjille oikeuden vastata yksittäisiin
          kysymyksiin.
        </p>
        <p>
          Samassa yhteydessä uudistimme näiden suoritusten näkymiä niin, että
          tehtävät tai kysymykset näkyvät nyt ylläpitäjälle suorituksen
          oletusnäkymänä. Samasta näkyvästä voit tehtävää tai kysymystä
          muokatessasi valita, voiko käyttäjä itse muokata tehtävää tai
          kysymystä.
        </p>
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Liitä kaikki vastuuhenkilöt suoritukseen"
      >
        Suorituksen Vastuuhenkilöt-sivun kautta voit nyt automaattisesti liittää
        kaikki alustan vastuuhenkilöt suoritukseen. Tällöin jokainen
        vastuuhenkilö voi hallita oman tiiminsä suoritusmerkintöjä kyseisessä
        suorituksessa. Voit myös yhä edelleen liittää vastuuhenkilöitä
        yksittäin.
      </UpdatesListItem>

      <UpdatesListItem title="Päivityksiä kalenteritapahtumiin">
        <ul>
          <li>
            Voit nyt asettaa viimeisen päivämäärän jolloin käyttäjät voivat
            liittyä tapahtumaan
          </li>
          <li>
            Voit nyt kopioida kalenteritapahtuman luodaksesi uuden tapahtuman,
            tämä onnistuu tapahtuman Ylläpito-sivulta
          </li>
          <li>
            Voit nyt helpommin hallita kalenteritapahtuman käyttäjiä
            valitsemalla useamman käyttäjän ja suorittamalla jonkin toiminnon
            valituille käyttäjille
          </li>
        </ul>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-08-31">
      <UpdatesListItem
        onlyForAdmin={true}
        title="Käyttäjän osaamisen tasot ja kuvaukset"
      >
        Käyttäjän osaamisiin voi nyt liittää tasoja ja kuvauksia. Osaamisiin voi
        myös liittää kategorioita. Osaamisia voi luoda, muokata ja poistaa
        keskitetysti Käyttäjät-sivun alta löytyvältä Käyttäjän osaaminen
        -sivulta.
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Käyttäjän osaamisen tasot ja kuvaukset"
      >
        <p>
          Käyttäjän osaamisiin voi nyt liittää tasoja ja kuvauksia. Osaamisiin
          voi myös liittää kategorioita. Osaamisia voi luoda, muokata ja poistaa
          keskitetysti Käyttäjät-sivun alta löytyvältä Käyttäjän osaaminen
          -sivulta.
        </p>
        <p>
          Osaamisten luominen, muokkaaminen ja poistaminen on oletuksena
          sallittu kaikille admin-käyttäjille, mutta halutessa tämän voi
          rajoittaa vain superadmin-käyttäjille Käyttäjän osaaminen -sivun alta
          löytyvän Asetukset-sivun kautta.
        </p>
      </UpdatesListItem>

      <UpdatesListItem title="Käyttäjän merkitsemät osaamiset">
        Käyttäjien on nyt mahdollista merkitä itselleen osaamisia. Jokaisen
        osaamisen asetuksissa voi erikseen valita saako käyttäjä itse merkitä
        osaamisen itselleen. Merkitseminen onnistuu sen jälkeen Omat tiedot
        -sivun kautta.
      </UpdatesListItem>

      <UpdatesListItem onlyForSuperadmin={true} title="Osaamisprofiilit">
        <p>
          Superadmin-käyttäjät voivat nyt luoda osaamisprofiileja joihin voi
          liittää yhden tai useamman osaamisen. Osaamisprofiilien hallinta
          onnistuu Käyttäjän osaaminen -sivun alta Osaamisprofiilit-sivulta.
          Täältä voi myös nähdä listan käyttäjistä joilla on osaamisprofiilia
          vastaava osaaminen.
        </p>
        <p>
          Yksittäisen käyttäjän osaamisia voi myös verrata kaikkiin
          osaamisprofiileihin käyttäjän profiili-sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-08-17">
      <UpdatesListItem title="Uusi Suoritushistoria-sivu profiilissa">
        Käyttäjän profiiliin on lisätty uusi Suoritushistoria-sivu joka kokoaa
        yhteen kaikki käyttäjän suorittamat kurssit, oppimispolut, suoritukset
        ja kalenteritapahtumat. Suoritushistorian voi myös ladata
        excel-tiedostona.
      </UpdatesListItem>

      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Vastuuhenkilön liittäminen suoritukseen"
      >
        <p>
          Suoritukset-sivun suorituksiin on lisätty pääkäyttäjille uusi
          Vastuuhenkilöt-sivu jolla suoritukseen voi liittää vastuuhenkilöitä.
          Tällöin vastuuhenkilö voi lisätä suoritusmerkinnän kaikille oman
          tiiminsä käyttäjille. Tehtävälistoissa vastuuhenkilö voi myös merkitä
          tehtävät suoritetuksi ja keskustelun muistiinpanoissa vastuuhenkilö
          voi lisätä vastauksia kysymyksiin.
        </p>
        <p>
          Vastuuhenkilö näkee hänelle osoitetut suoritukset joko
          Suoritukset-sivulta tai Tiimi-sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-05-05">
      <UpdatesListItem title="Uusi hakusivu">
        Voit nyt hakea kursseja, oppimispolkuja, ryhmiä, suorituksia ja
        kalenteritapahtumia uudelta hakusivulta. Haku kursseista hakee myös
        kurssin sisällöstä. Pääset hakusivulle etusivun hakukentän kautta tai
        yläpalkin ikonista.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-04-20">
      <UpdatesListItem title="Omat oppimispolut etusivulla">
        Käyttäjät jotka osallistuvat johonkin oppimispolkuun näkevät nyt
        viimeksi avatut omat oppimispolkunsa etusivulla.
      </UpdatesListItem>
      <UpdatesListItem title="Saatavilla olevat kurssit ja oppimispolut etusivulla">
        Etusivulla näkyy nyt oletuksena saatavilla olevat kurssit ja
        oppimispolut. Nämä tulevat näkyviin jos etusivua ei ole mukautettu. Jos
        etusivua on jo ehditty mukauttaa, niin etusivun näkymä ei muutu.
      </UpdatesListItem>
      <UpdatesListItem
        onlyForSuperadmin={true}
        title="Ryhmän liittäminen vastuuhenkilölle"
      >
        Superadmin voi nyt liittää ryhmän vastuuhenkilölle. Tämä tarkoittaa,
        että ryhmän käyttäjistä tulee vastuuhenkilön vastattavia käyttäjiä. Voit
        yhä lisätä vastattavia käyttäjiä suoraan tai attribuuttiehtojen avulla,
        mutta tällä tavoin sinun ei tarvitse hallita käyttäjiä kahdessa eri
        paikassa jos sinulla on jo olemassa olevia ryhmiä joita voi hyödyntää.
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2023-04-13">
      <UpdatesListItem onlyForAdmin={true} title="Uusi etusivu">
        <p>
          Lisäsimme uuden etusivun, jossa käyttäjä näkee hänelle ajankohtaista
          sisältöä. Käyttäjä voi saada ilmoituksia vanhenevista suorituksista,
          lähestyvistä tavoiteaikatauluista tai tulevista tapahtumista.
        </p>
      </UpdatesListItem>
      <UpdatesListItem onlyForSuperadmin={true} title="Uusi etusivu">
        <p>
          Lisäsimme uuden etusivun, jossa käyttäjä näkee hänelle ajankohtaista
          sisältöä. Käyttäjä voi saada ilmoituksia vanhenevista suorituksista,
          lähestyvistä tavoiteaikatauluista tai tulevista tapahtumista.
        </p>
        <p>Alustan pääkäyttäjänä voit myös muokata miltä etusivu näyttää:</p>
        <ul>
          <li>Voit lisätä bannerikuvan etusivun yläosaan</li>
          <li>Voit näyttää infotekstin kaikille käyttäjille</li>
          <li>Voit valita mitä ilmoituksia käyttäjälle näytetään</li>
          <li>
            Voit lisätä mukautettuja kursseista tai oppimispoluista koostuvia
            osioita etusivulle
          </li>
        </ul>
        <p>
          Löydät etusivun asetukset Superadmin{` -> `}Asetukset -sivulta. Löydät
          myös tarkemman kuvauksen etusivun muutoksista täältä:{' '}
          <Link
            external={true}
            href="https://www.vuolearning.com/fi/campaigns/oppimisalustan-muutokset"
            openInNewTab={true}
            text="https://www.vuolearning.com/fi/campaigns/oppimisalustan-muutokset"
          />
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Päivitetyt Kurssit, Oppimispolut ja Suoritukset -sivut">
        <p>
          Kurssit, Oppimispolut ja Suoritukset -sivut on päivitetty ja niille on
          lisätty parannettuja suodatusmahdollisuuksia. Sivut näkyvät nyt myös
          kaikille käyttäjille niin, että he näkevät sisältöjä joihin he
          osallistuvat tai jotka he ovat suorittaneet.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oppimispolun teemakuva">
        <p>Voit nyt lisätä teemakuvan myös oppimispolulle.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Suoritukset ja kalenteritapahtumat oppimispoluissa">
        <p>
          Suorituksia ja kalenteritapahtumia voi nyt lisätä osaksi
          oppimispolkua. Näiden osalta ylläpitäjän pitää merkitä suoritus tai
          kalenteritapahtuma suoritetuksi. Tämän muutoksen myötä päivitimme myös
          sanastoa niin, että oppimispolku koostuu nyt askelista.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Vaihtoehtoiset sisällöt oppimispolussa">
        <p>
          Voit nyt lisätä vaihtoehtoisia sisältöjä oppimispolkuun. Yksi
          oppimispolun askel voi esimerkiksi koostua useammasta kurssista,
          jolloin käyttäjän pitää suorittaa yksi näistä kursseista jotta askel
          merkitään suoritetuksi.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Joustavammat sähköpostimuistutukset">
        <p>
          Jos olet aktivoinut sähköpostimuistutuksia vanhenevista suorituksista
          tai lähestyvistä tavoiteaikatauluista, voit nyt valita kuinka monta
          muistutusviestiä lähetetään ja milloin viestit lähetetään.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-12-12">
      <UpdatesListItem title="Käyttäjän kurssianalytiikan poistaminen">
        <p>
          Voit nyt poistaa kaiken käyttäjään liittyvän kurssianalytiikan, mukaan
          lukien lukemisanalytiikan, videoanalytiikan ja tehtävävastaukset. Tämä
          onnistuu käyttäjän kohdalta valikosta Tehtävät ja analytiikka
          -sivulla.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Keskustelukommenttien järjestys">
        <p>
          Voit nyt järjestää keskustelukommentit uusimpien tai vanhimpien
          kommenttien mukaan.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Yksityiskohtaisempi vastausdata H5P-tehtävissä">
        <p>
          Olemme päivittäneet miten vastausdataa kerätään ja näytetään
          H5P-tehtävissä. Päivitetty vastausdata on saatavilla H5P-tehtävissä
          jotka on lisätty päivityksen jälkeen.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-11-29">
      <UpdatesListItem title="Monipuolisemmat attribuuttiehdot">
        <p>
          Attribuuttiehdot (esimerkiksi ryhmissä) tukevat nyt monipuolisempia
          ehtoja. Voit esimerkiksi määrittää, että käyttäjä sisällytetään jos
          käyttäjäattribuutti ei ole yhtä kuin jokin arvo.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uudistettu elementtien siirto editorissa">
        <p>
          Elementtien siirto editorissa toimii nyt uudella tavalla. Voit painaa
          elementin kohdalla Siirrä-painiketta, halutessasi valita useamman
          elementin, ja sen jälkeen sijoittaa elementit uuteen kohtaan luvussa.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Käyttäjien suodattaminen kirjautumisen mukaan">
        <p>
          Voit nyt suodattaa käyttäjiä Käyttäjät-sivulla sen mukaan onko
          käyttäjä joskus kirjautunut alustalle tai jos käyttäjä ei koskaan ole
          kirjautunut alustalle.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-10-27">
      <UpdatesListItem title="Vastuuhenkilön tiimisivu">
        <p>
          Vastuuhenkilöille on lisätty uusi Tiimi-sivu josta he näkevät tietoja
          vastattavista käyttäjistään. Tiimi-sivun asetuksista vastuuhenkilö voi
          myös tilata yteenveto-sähköpostin vastattavien käyttäjien
          viimeaikaisista aktiviteeteista.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-09-30">
      <UpdatesListItem title="Uusi tapahtumakalenteri">
        <p>
          Voit nyt luoda tapahtumia uuteen tapahtumakalenteriin.
          Tapahtumakalenterin avulla on helppo jakaa tietoa tulossa olevista
          koulutuksista, webinaareista tai muista tapahtumista. Kalenteri on
          yhteinen kaikille alustan käyttäjille, ja myös ilmoittautuminen
          tapahtumiin voidaan tehdä kalenterin kautta. Linkki kalenteriin löytyy
          sivuston päävalikosta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Käyttäjien tuonti CSV-tiedostolla">
        <p>
          Superadmin-käyttäjät voivat nyt luoda uusia käyttäjätilejä tuomalla
          käyttäjätietoja sisältävän CSV-tiedoston alustalle. Tämä vaihtoehto
          löytyy Käyttäjät-sivulta, jossa näytetään myös esimerkki siitä minkä
          muotoinen tiedoston tulisi olla.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uusia suodatusvaihtoehtoja Käyttäjät-sivulla">
        <p>
          Lisäsimme uuden vaihtoehdon suodattaa käyttäjätilejä
          Käyttäjät-sivulle. Voit nyt suodattaa käyttäjätilejä
          sähköpotiosoitteella tai ilman sähköpostiosoitetta, vanhentuneita tai
          lukittuja tilejä tai admin- ja superadmin-tilejä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Tehtäväpisteet luvussa">
        <p>
          Käyttäjät näkevät nyt tehtäväpisteet jokaisesta vastatusta tehtävästä
          suoraan luvun sisällä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-08-25">
      <UpdatesListItem title="Käyttäjän osaaminen ja osaamistavoitteet">
        <p>
          Käyttäjän tietoihin voi nyt liittää osaamista ja osaamistavoitteita.
          Käyttäjälle voidaan merkitä osaaminen joko manuaalisesti
          admin-käyttäjän toimesta tai automaattisesti esimerkiksi suorittamalla
          kurssin. Jokainen läyttäjä voi itse lisätä osaamistavoitteita omalta
          profiilisivultaan.
        </p>
        <p>
          Admin-käyttäjät voivat hakea käyttäjiä osaamisen tai
          osaamistavoitteiden mukaan Käyttäjät-sivulta. He voivat myös
          tarkastella analytiikkatietoja osaamisesta ja osaamistavoitteista
          Analytiikka-sivulta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Päivitetty käyttäjäprofiili">
        <p>
          Olemme tehneet joitakin päivityksiä käyttäjäprofiiliin ja lisänneet
          aikajanan joka näyttää yhteenvedon käyttäjän tärkeistä tapahtumista.
          Käyttäjät voivat nyt myös ladata kuvan omaksi profiilikuvakseen.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Vastuuhenkilöt">
        <p>
          Superadmin-käyttäjät voivat nyt merkitä admin-käyttäjiä toisen
          käyttäjien vastuuhenkilöksi. Vastuuhenkilöt näkevät analytiikkatietoja
          käyttäjien kaikilta kursseilta, oppimispoluilta ja suorituksilta
          alustalla. Vastuuhenkilö voi tarkastella analytiikkatietoja
          Käyttäjät-sivulta ja käyttäjän profiilisivulta.
        </p>
        <p>
          Olemme samalla poistaneet käytöstä järjestelmän laajuisen analytiikan
          katseluoikeuden joka aiemmin oli osa ryhmiä. Kaikki käyttäjät joilla
          oli tämä oikeus on automaattisesti lisätty vastuuhenkilöiksi ryhmän
          käyttäjille.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Enemmän vaihtoehtoisia oikeuksia admin-käyttäjille">
        <p>
          Superadmin-käyttäjät voivat nyt tarkemmin hallita mitä oikeuksia
          admin-käyttäjille sallitaan. Admin-käyttäjälle voi antaa oikeuden
          luoda kurssi, luoda ryhmä, luoda oppimispolku, luoda suoritus, hallita
          käyttäjiä ja hallita käyttäjäattribuuttien asetuksia.
        </p>
        <p>
          Kaikille olemassa oleville admin-käyttäjille on automaattisesti
          lisätty oikeus hallita käyttäjiä sekä luoda kursseja, ryhmiä,
          oppimispolkuja ja suorituksia.
        </p>
        <p>
          Osana tätä muutosta olemme myös päivittäneet "Muokkaa
          käyttäjiä"-oikeuden "Hallitse käyttäjiä"-oikeudeksi. Aiemmin kaikilla
          käyttäjillä oli oikeus poistaa käyttäjätili ja käyttäjäattribuuttien
          muokkaaminen oli mahdollista vain "Muokkaa käyttäjiä"-oikeudella.
          "Hallitse käyttäjiä"-oikeus antaa oikeuden sekä muokata käyttäjien
          tietoja, että poistaa käyttäjätilin. Tämän muutoksen myötä joillakin
          admin-käyttäjillä joilla ei aiemmin ollut oikeutta muokata käyttäjien
          tietoja voi nyt olla mahdollisuus muokata tietoja, mutta tarvittaessa
          superadmin-käyttäjä voi poistaa oikeuden admin-käyttäjältä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-06-20">
      <UpdatesListItem title="Eri suoritustyypit">
        <p>
          Voit nyt luoda eri tyyppisiä suorituksia. Nimesimme samalla "Ulkoiset
          suoritukset" sivun uudelleen "Suoritukset" sivuksi. Suorituksia on
          neljää eri tyyppiä:
        </p>
        <ul>
          <li>
            <em>Suoritus</em> on sama kuin aiempi ulkoinen suoritus
          </li>
          <li>
            <em>Keskustelun muistiinpanot</em> -suoritusta voi käyttää
            esimerkiksi tavoitekeskustelun ylöskirjaamiseksi
          </li>
          <li>
            <em>Saavutus</em> -suoritusta voi käyttää yksinkertaisten
            saavutusten merkkaamiseen
          </li>
          <li>
            <em>Tehtävälista</em> -suoritusta voi käyttää esimerkiksi
            perehdytyksen apuna
          </li>
        </ul>
      </UpdatesListItem>
      <UpdatesListItem title="Käyttäjät-sivun suodattimet">
        <p>
          Tiivistimme Käyttäjät-sivun kurssin ja ryhmän mukaan suodattamisen
          yhden "Suodata" valikon alle. Samalla lisäsimme mahdollisuuden
          suodataa käyttäjiä oppimispolkujen ja suoritusten mukaan.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Admin-ryhmät">
        <p>
          Superadmin-käyttäjät voivat nyt jakaa muita admin- tai
          superadmin-käyttäjiä admin-ryhmiin. Admin-ryhmän voi lisätä
          esimerkiksi kurssin omistajaksi tai ylläpitäjäksi samaan tapaan kuin
          yksittäisen käyttäjän. "Kaikki ylläpitäjät" admin-ryhmä on luotu
          oletuksena, ja tämä ryhmä sisältää kaikki admin- ja
          superadmin-käyttäjät.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-05-13">
      <UpdatesListItem title="Kurssin tavoiteaikataulu">
        <p>
          Yksittäisille kursseille voi nyt asettaa tavoiteaikataulun samaan
          tapaan kuin oppimispoluille aiemmin. Tavoiteaikataulusta voi lähettää
          muistutuksia käyttäjälle, ja pääsyn kurssille voi halutessa estää
          tavoiteaikataulun päättymisen jälkeen. Voit asettaa kurssille
          tavoiteaikataulun kurssin Asetukset-sivun kautta ja muokata
          yksittäisten käyttäjien tavoiteaikataulua Jaa-sivulta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Pääsyoikeuden pyytäminen kurssille">
        <p>
          Kurssin Jaa-sivulle on nyt lisätty uusi pääsyasetus, jolla kaikki
          alustan käyttäjät voivat pyytää pääsyoikeutta kurssille. Tällaiset
          kurssit näkyvät etusivulla "Saatavilla"-näkymässä. Ylläpitäjä voi
          hyväksyä tai hylätä käyttäjän pyynnön Jaa-sivulta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Notifikaatiot">
        <p>
          Käyttäjä näkee nyt notifikaatioita eri tapahtumista yläpalkista
          notifikaatio-ikonin alta. Notifikaatioita näytetään esimerkiksi
          tehtävien arvioinneista, keskusteluvastauksista, tavoiteaikatauluista
          tai uusista luvuista kursseilla.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Muutos avoimen kysymyksen oletuspisteisiin">
        <p>
          Avoimen kysymyksen oletuspisteet on muutettu 0 pisteeksi, koska
          oletuksena avoin kysymys ei ole arvioitava. Jos tehtävän asettaa
          arvioitavaksi voi sille samalla asettaa tehtäväpisteet.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-03-28">
      <UpdatesListItem title="Usean käyttäjän samanaikainen muokkaaminen">
        <p>
          Käyttäjät-sivu tukee nyt toimintojen tekemistä usealle käyttäjälle
          samanaikaisesti. Toistaiseksi tuetut toiminnot ovat usean käyttäjän
          poistaminen, usean käyttäjätilin lukitseminen ja usean käyttäjän
          attribuuttien muokkaaminen. Löydät toiminnot käyttäjälistan oikeasta
          yläkulmasta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Viestin lähettäminen kurssin, ryhmän tai oppimispolun käyttäjille">
        <p>
          Kurssin käyttäjille voi nyt lähettää viestin suoraan kurssin Tehtävät
          ja analytiikka -sivulta. Ryhmän ja oppimipolun käyttäjille voi myös
          lähettää viestin suoraan ryhmän tai oppimispolun Seuraa-sivulta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Kurssin yhteenveto-sähköposti">
        <p>
          Voit nyt tilata kurssikohtaisen yhteenveto-sähköpostin kurssin
          tapahtumista edellisen päivän, viikon tai kuukauden aikana. Viestin
          avulla saat tietoa uusista tehtävävastauksista, palautteista,
          keskustelukommenteista, chat-viesteistä tai suorituksista. Sähköpostin
          voi tilata kurssin asetuksista.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oppimispolun todistuksen lähettäminen">
        <p>
          Oppimispolun asetuksissa on nyt mahdollista määrittää, että
          oppimispolun todistus lähetetään automaattisesti käyttäjälle tai
          ylläpitäjälle.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Sähköpostimuistutus ulkoisten suoritusten vanhenemisesta">
        <p>
          Voit nyt halutessasi saada sähköpostiilmoituksen, jos käyttäjän
          ulkoinen suoritus on vanhenemassa.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-03-11">
      <UpdatesListItem title="Emojit ja reaktiot keskustelukommenteissa">
        <p>
          Keskustelukommentteihin voi nyt lisätä emojeja. Kommentteihin voi nyt
          myös lisätä reaktioita.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oppimispolun kuvaus">
        <p>
          Oppimispolkuun voi nyt liittää kuvauksen. Teksti näkyy käyttäjälle
          oppimispolun otsikon alla.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-02-28">
      <UpdatesListItem title="Päivitetty etusivun kurssinäkymä">
        <p>
          Päivitimme etusivun kurssinäkymää niin, että ylläpidettävät kurssit
          näytetään aina listamuodossa ja opiskeltavat kurssit aina ruudukkona.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Muuttuneiden suoritustietojen näyttäminen">
        <p>
          Kurssin suoritustietojen yhteydessä näytetään nyt, jos tiedot ovat
          muuttuneet sen jälkeen, kun käyttäjä suoritti kurssin. Näin voi käydä,
          jos käyttäjä esimerkiksi palaa lukemaan kurssia myöhemmin.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oppimispolun seuraavan kurssin näyttäminen">
        <p>
          Kurssin viimeisen luvun lopussa näytetään nyt linkki oppimispolun
          seuraavalle kurssille, jos kurssi on osa oppimispolkua.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Parannuksia videosoittimeen">
        <p>
          Videosoitin muistaa nyt missä kohtaa käyttäjä viimeksi katsoi videota
          jos toisto jää kesken. Videosoittimeen on myös lisätty painikkeet
          joilla videossa voi siirtyä 10 sekuntia eteenpäin tai taaksepäin.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2022-01-17">
      <UpdatesListItem title="Otsikkotasot">
        <p>
          Alusta tukee nyt lisää otsikkotasoja. Otsikkoelementin valinnoista
          voit määrittää onko luvussa näkyvä otsikko H2 vai H3 tasoinen.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Otsikon alla olevan sisällön valitseminen">
        <p>
          Muokkausnäkymässä voi nyt valita kaikki otsikon alla olevat
          sisältöelementit. Valitse ensin otsikko elementin oikealta puolelta ja
          valitse sitten valikosta "Valitse kaikki elementit tämän otsikon
          alla".
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Näppäinoikotiet tekstin muotoiluun">
        <p>
          Tekstin lihavointi (ctrl/cmd + b), kursivointi (ctrl/cmd + i),
          alleviivaus (ctr/cmd + u) ja koodin korostaminen (ctrl/cmd + shift +
          c) onnistuu nyt näppäinoikoteiden avulla.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oikeiden monivalintavaihtoehtojen vaatiminen">
        <p>
          Jos monivalintatehtävässä on useampi oikeaksi merkitty
          vastausvaihtoehto, voit nyt valita kuinka monta vaihtoehtoa käyttäjän
          täytyy valita jotta vastaus lasketaan oikeaksi.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Oman vastauksen poistaminen lukijanäkymässä ylläpitäjille">
        <p>
          Ylläpitäjä voi nyt poistaa oman vastauksensa suoraan lukijanäkymästä,
          minkä on tarkoitus helpottaa tehtävien testaamista.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Arvioimattomien tehtävien korostus">
        <p>
          Arvioimattomat tehtävät korostetaan nyt kurssin Tehtävät ja
          analytiikka -sivulla. Yksittäisen tehtävän sivulla voit myös suodattaa
          vain arvioimattomat tehtävävastaukset.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Kurssisuorituksen manuaalinen merkitseminen usealle käyttäjälle">
        <p>
          Voit nyt merkitä kurssisuorituksen manuaalisesti usealle käyttäjälle
          kerralla. Tämä tapahtuu Tehtävät ja analytiikka -sivulla valitsemalla
          oikean yläkulman valikosta "Merkitse useita suorituksia".
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uusi Keskustelut -sivu">
        <p>
          Kurssin Tehtävät ja analytiikka -valikon alle on lisätty uusi
          Keskustelut -sivu, joka sisältää yhteenvedon kaikista kurssin
          keskusteluista. Voit myös kommentoida keskusteluja suoraan tämän
          näkymän kautta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Sähköpostimuistutukset ylläpitäjille vanhenevista suorituksista ja kurssin tavoiteaikataulun päättymisestä">
        <p>
          Kurssin läpäisyraja-asetuksista voi nyt halutessa asettaa
          sähköpostimuistutuksia lähetettäväksi ylläpitäjille vanhenevista
          kurssisuorituksista. Oppimispolun asetuksista voi asettaa muistutuksia
          lähetettävksi ylläpitäjille jos kurssin tavoiteaikataulu on
          päättymässä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Norjan ja viron kielen käyttöliittymäkäänökset">
        <p>
          Lisäsimme uudet norjan ja viron kielen käännökset käyttöliittymästä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-12-21">
      <UpdatesListItem title="Ulkoiset suoritukset">
        <p>
          Voit nyt luoda ulkoisia suorituksia alustalle ja liittää niihin
          käyttäjiä. Ulkoisia suorituksia voi käyttää alustan ulkopuolella
          käytyjen koulutusten kirjaamiseen. Käyttäjän ulkoiset suoritukset voi
          nähdä käyttäjän profiilista Suoritukset-sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-11-05">
      <UpdatesListItem title="Vaihda sisältöelementin tyyppiä">
        <p>
          Voit nyt vaihtaa sisältöelementin tyyppiä muokkausnäkymässä teksti-,
          otsikko-, lista- ja lainaus-elementeille. Näin sinun ei tarvitse luoda
          uutta elementtiä ja kopioida sisältöä siihen jos haluat esimerkiksi
          muuttaa tekstielementin otsikoksi. Löydät tämän valinnan
          muokkausnäkymästä elementin vasemmasta alalaidasta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Ryhmän ylläpitäjät rajatuilla oikeuksilla">
        <p>
          Voit nyt lisätä ryhmään ylläpitäjiä rajatuilla oikeuksilla. Valittavat
          oikeudet ovat käyttäjien lisääminen ja poistaminen, kurssien hallinta
          ja ryhmän analytiikan tarkastelu.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-10-13">
      <UpdatesListItem title="Tekstin korostus">
        <p>
          Voit nyt korostaa tekstielementin sisällön valitsemalla elementille
          taustavärin tai reunuksen muokkausnäkymässä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="H5P-elementti">
        <p>
          Voit nyt ladata H5P-paketin suoraan osaksi sisältöä. H5P-elementin voi
          halutessaan asettaa tehtäväksi, jolloin siitä kerätään pisteitä jotka
          voivat vaikuttaa kurssin suoritukseen. H5P-elementti löytyy editorissa
          Embed-valinnan alta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-10-04">
      <UpdatesListItem title="Kysely-sisältöelementti">
        <p>
          Löydät nyt muokkausnäkymästä uuden sisältöelementin likert-kyselyjä
          varten.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Täydennä-tehtävätyyppi">
        <p>
          Löydät nyt muokkausnäkymästä Tehtävä-valinnan alta uuden
          sisältöelementin jolla voit pyytää käyttäjiä täydentämään puuttuvat
          sanat.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Järjestä-tehtävätyyppi">
        <p>
          Löydät nyt muokkausnäkymästä Tehtävä-valinnan alta uuden
          sisältöelementin jolla voit pyytää käyttäjiä järjestämään vaihtoehdot
          oikeaan järjestykseen.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Tehtävien pisteiden määrittäminen">
        <p>
          Muokkausnäkymässä voit nyt määrittää jokaisen tehtävän kohdalla kuinka
          monen pisteen arvoinen tehtävä on.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-08-31">
      <UpdatesListItem title="Manuaalinen kurssisuorituksen merkitseminen">
        <p>
          Voit nyt manuaalisesti merkitä kurssin suoritetuksi tai poistaa
          kurssisuorituksen yksittäiseltä käyttäjältä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-08-13">
      <UpdatesListItem title="Uudet analytiikka-sivut">
        <p>
          Pääset nyt tarkastelemaan uutta analytiikkaa käyttäjistä, kursseista
          ja oppimispoluista ylävalikon kautta.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Haku muokkausnäkymässä">
        <p>Voit nyt etsiä sisältöä luvuista muokkausnäkymässä.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Videotiedostojen lataaminen">
        <p>
          Voit nyt ladata omalle koneellesi alustalle lataamasi videotiedoston
          muokkausnäkymässä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Yhtenäistetty käyttäjien hallinta">
        <p>
          Kolmen käyttäjätason käyttäjien hallinta on nyt yhtenäistetty
          Käyttäjät-sivulle. Superadmin-näkymässä voi jatkossa hallita
          käyttäjien ylläpito-oikeuksia.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-06-04">
      <UpdatesListItem title="SCORM-analytiikka">
        <p>
          Voit nyt seurata SCORM-pakettien etenemisen analytiikkaa. Tuettuja
          SCORM-pakettien muotoja ovat nyt SCORM1.2 ja SCORM2004.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uusi numeerinen kysymys -sisältöelementti">
        <p>
          Lisäsimme numeerinen kysymys -sisältöelementin, jolla käyttäjä voi
          vastata kysymykseen numerolla. Vastauksesta saa pisteitä jos vastaus
          oli oikein.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-05-19">
      <UpdatesListItem title="Päivitetty ryhmän raportointi">
        <p>
          Päivitimme ryhmän raportointia niin, että ryhmän omistaja voi nyt
          seurata ryhmään lisättyjen käyttäjien etenemistä ryhmän sivulta.
        </p>
        <p>
          Lisäsimme myös analytiikan katseluoikeudet -asetuksen, jolla voi antaa
          ylläpitäjälle oikeuden tarkastella ryhmään lisättyjen käyttäjien
          kaikkia kursseja, myös niitä joita ei ole lisätty ryhmään. Tätä
          asetusta voi toistaiseksi muokata vain superadmin-käyttäjä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-05-04">
      <UpdatesListItem title="Kaksivaiheinen tunnistautuminen">
        <p>
          Kaksivaiheinen tunnistautuminen on nyt mahdollista
          tunnistussovelluksen avulla. Kirjautuminen tapahtuu salasanalla ja
          sovelluksen antamalla vahvistuskoodilla. Kaksivaiheisen
          tunnistautumisen voi aktivoida Omat tiedot -sivulta.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-03-11">
      <UpdatesListItem title="Oppimispolut">
        <p>
          Oppimispolkujen avulla voit määrittää joukon kursseja jotka käyttäjän
          tulee suorittaa järjestyksessä. Löydät lisää tietoa oppimispoluista{' '}
          <Link
            external={true}
            openInNewTab={true}
            href="https://academy.vuolearning.fi/courses/kayttoohjeet"
            text="käyttöoppaasta"
          />
          .
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Tavoiteaikataulut">
        <p>
          Oppimispolkujen kautta voit asettaa kurssien suorittamiselle myös
          tavoiteaikataulun ja halutessa estää pääsyn kurssille kun määräaika on
          päättynyt. Tavoiteaikataulu voidaan asettaa kurssikohtaisesti kaikille
          käyttäjille mutta myös käyttäjäkohtaisesti yksittäisille käyttäjille.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uudistettu etusivun kurssinäkymä">
        <p>
          Oppimispolkujen seurauksena myös etusivun kurssinäkymä on uudistunut.
          Käyttäjä näkee nyt oletuksena yhteenvedon viimeksi avatuista
          kursseista ja ylläpitäjä viimeksi muokatuista kursseista.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-02-25">
      <UpdatesListItem title="Mukautettu teksti kurssitodistuksissa">
        <p>
          Voit nyt lisätä mukautetun tekstin kurssitodistukseen. Näet myös
          esikatselukuvan kurssitodistuksesta kurssin läpäisyraja-asetuksissa.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2021-01-18">
      <UpdatesListItem title="Keskustelukommenttien muokkaus">
        <p>Käyttäjät voivat nyt muokata omia keskustelukommenttejaan.</p>
      </UpdatesListItem>
      <UpdatesListItem title="Anonyymit keskustelukommentit">
        <p>
          Voit nyt sallia anonyymien kommenttien lähettämisen
          keskusteluelementissä.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Monivalinnan palauteasetukset">
        <p>
          Voit nyt asettaa palautetekstin jokaiselle vaihtoehdolle erikseen tai
          asettaa palautetekstit sen mukaan onko vastaus oikein vai väärin.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Päivityksiä analytiikka- ja tehtävädatan hakemiseen">
        <p>
          Analytiikka- ja tehtävädatan haku tehdään nyt välimuistista minkä
          pitäisi parantaa suorituskykyä isoilla datamäärillä.
        </p>
      </UpdatesListItem>
    </UpdatesItem>

    <UpdatesItem date="2020-10-14">
      <UpdatesListItem title="Kurssikategoriat">
        <p>
          Kursseihin voi nyt liittää kategorioita. Voit suodattaa kursseja
          etusivulla kategorian mukaan.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Alustava SCORM-tuki">
        <p>
          Voit nyt ladata SCORM-paketteja Embed-elementin kautta. SCORM-paketit
          eivät vielä tue tehtävien tai analytiikan tallennusta, mutta
          suunnittelemme tukevamme näitä tulevaisuudessa.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Koodi-elementti">
        <p>
          Päivitimme Esimuotoiltu-elementin Koodi-elementiksi, johon voit
          halutessasi lisätä syntaksin korostuksen.
        </p>
      </UpdatesListItem>
      <UpdatesListItem title="Uusi sivu alustan päivityksille" />
    </UpdatesItem>
  </div>
);

export default UpdatesContentFi;
